import gql from 'graphql-tag';

const PRIVACY_POLICY_PAGE_QUERY = gql`
    query {
        privacyPolicyPage {
            content {
                title
                subtitle
                text
                image {
                    url
                }
            }
        }
    }
`;

export default PRIVACY_POLICY_PAGE_QUERY;
